import type { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'app/components/Icon';
import logoIcon from 'app/icons/logo.svg';
import arrowIcon from 'app/icons/arrow.svg';
import ErrorBoundary from 'app/common/ErrorBoundary/index';

import style from './style.scss';

const AppErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const [t] = useTranslation();

  return (
    <ErrorBoundary
      render={() => (
        <div className={style.container}>
          <Icon href={logoIcon} className={style.logo} />
          <div className={style.content}>
            <div className={style.title}>{t('app_crash-title')}</div>
            <div className={style.sentence}>
              {t('app_crash-sentence_1')}
              <br />
              {t('app_crash-sentence_2')}
            </div>

            <button className={style.button} onClick={() => location.reload()}>
              <Icon href={arrowIcon} className={style.arrowIcon} />
              {t('app_crash-reload')}
            </button>
            <a href="mailto:hello@pandascore.co" className={style.button}>
              <Icon href={arrowIcon} className={style.arrowIcon} />
              {t('app_crash-contact')}
            </a>
          </div>
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};

AppErrorBoundary.displayName = 'AppErrorBoundary';

export default AppErrorBoundary;
